import { Format } from './format.interface';
import { Card, Query } from '@deckplan.io/common';

export class Vintage extends Format {

    public addCardsQuery(): Query {
        return {
            dataField: {
                title: 'Legalities',
                field: 'legalities',
                dataType: 'string'
            },
            operation: 'includes',
            value: `"vintage":"legal"`
        };
    }

    public validate(): Card[] {
        return this.deck.cards.filter(c =>
            // All cards not legal in vintage are invalid
            c.legalities.vintage === 'not_legal'
        );
    }

}
